import { literal } from "zod";
import { ProductDetailsParser } from "../../concierge-conversation/product-details-db-parser";
import { ContentType } from "../../conversation";
import { BaseMessageDbParser } from "../base-conversation-message-db-parser";
import { AutoGeneratedFieldsSchema } from "../message-parser-utils";

//TODO: I think we can remove this when we purge old concierge code
export const ProductDetailsMessageSchema = BaseMessageDbParser.extend({
  contentType: literal(ContentType.TOOL_CALL_PRODUCT_INFO),
  structuredContent: ProductDetailsParser.optional(),
});

export const ProductDetailsMessageDbParser = ProductDetailsMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);
